import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { StylePrompt } from '@/features/image-rendering/components/style-prompt';
import { StyleSettings } from '@/features/image-rendering/components/style-settings/style-settings';

import { useAiRenderingCanGenerate } from '../hooks/use-ai-rendering-can-generate';
import { useSyncSharedToLegacyImageRendering } from '../hooks/use-sync-shared-to-legacy-image-rendering';

type Props = {
  isMobileView?: boolean;
  onContinue?: () => void;
  onCreate?: () => void;
  isCreating?: boolean;
  canGenerate?: boolean;
};

export const AiRenderingTab = ({
  isMobileView,
  onContinue,
  onCreate,
  isCreating,
  canGenerate: canGenerateProp,
}: Props) => {
  useSyncSharedToLegacyImageRendering();
  const { t } = useTranslation();

  const canGenerateFromHook = useAiRenderingCanGenerate();
  const canGenerate = canGenerateProp ?? canGenerateFromHook;

  const showContinue = Boolean(isMobileView);

  return (
    <div className="flex min-h-full w-full flex-col gap-3 sm:w-[287px]">
      <StyleSettings />
      {appConfig.stylePrompt ? <StylePrompt /> : null}

      <div className="sticky bottom-0 z-20 mt-auto bg-white pt-2">
        <div className="flex w-full justify-center">
          {showContinue ? (
            <Button
              disabled={!canGenerate}
              className="h-11 w-full gap-3 rounded-sm text-base font-semibold"
              type="button"
              onClick={onContinue}
            >
              <Sparkles aria-hidden className="size-5" />
              {t('continue')}
            </Button>
          ) : (
            <Button
              disabled={!canGenerate || isCreating}
              className="h-11 w-full gap-3 rounded-sm text-base font-semibold"
              type="button"
              onClick={onCreate}
            >
              <Sparkles aria-hidden className="size-5" />
              {t('create')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
